import type { DeepPartial } from '@luna/utils-ts';

import type { UserProfileFeatureConfig } from './type';

export const userProfile: DeepPartial<UserProfileFeatureConfig> = {
    displayDisabledSelfEmployedStatus: true,
    numberOfChildrenOptional: false,
    showNumberOfChildren: false,
    taxInfo: {
        isLastTaxInfoDeletable: false,
    },
};
